import { useContext } from "react";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";

export const Post=async(link:string,body:string,tipo:string,token:string)=>
{
     const resultado = await ejecutarFetch(
        link,
        "POST",
        tipo,
        token,
        body
    );

    return resultado?.access_token; 
}

export const Post2=(link:string,body:any,tipo:string,token:string)=>
{
    
   return ejecutarFetch(
        link,
        "POST",
        tipo,
        token,
        body
    );         
}

export const PostSinToken=(link:string,body:any,tipo:string)=>
    {
        
         return ejecutarFetch(
        link,
        "POST",
        tipo,
        undefined,
        body
    );     
    }

export const Get=(link:string,tipo:string,token:string)=>
{
    
     return ejecutarFetch(
        link,
        "GET",
        tipo,
        token
    );
    
}
export const GetSinToken=(link:string,tipo:string)=>
    {
        
        return ejecutarFetch(
        link,
        "GET",
        tipo,
        undefined
    );
        
    }

export const Put=(link:string,tipo:string,token:string,cuerpo:string)=>
{
    return ejecutarFetch(
        link,
        "PUT",
        tipo,
        token,
        cuerpo
    );
    
}

export const PostSinContent=(link:string,body:any,token:string)=>
{
    
    return ejecutarFetch(
        link,
        "POST",
        undefined,
        token,
        body
    );          
}

export const GetSinRetorno=(link:string,tipo:string,token:string)=>
{
    return ejecutarFetch(
        link,
        "GET",
        tipo,
        token
    );
    
    
}

export const PostSinRetorno=(link:string,body:any,tipo:string,token:string)=>
{
   return ejecutarFetch(
        link,
        "POST",
        tipo,
        token,
        body
    );      
    
    
}

async function ejecutarFetch(
    link: string,
    metodo: string,
    tipo?: string,
    token?: string,
    body?: BodyInit
) {

    const headers = new Headers();

    if (tipo) {
        headers.append("Content-Type", tipo);
    }

    if (token) {
        headers.append("Authorization", `Bearer ${token}`);
    }

    const response = await fetch(link, {
        method: metodo,
        headers,
        body,
        redirect: "follow"
    });

    if (!response.ok) {
        throw new Error(
            `Error ${response.status}: ${response.statusText}`
        );
    }

    const texto = await response.text();

    if (!texto) {
        return null;
    }

    try {
        return JSON.parse(texto);
    } catch {
        return texto;
    }
}